/* Imports */
import { API_HELPER } from "@/helpers/api.js";
import { ENVIRONMENT_HELPER } from "@/helpers/environment.js";
import { authHeader } from "@/helpers/auth-header.js";

/* Exports */
// API services that can be invoked on the modules
export const PEOPLE_SERVICE = {
    list,
    add,
    edit,
    get,
    updateStatus,
    updateCredentials
};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "Users";

/* Services */
function list(pageNumber, resultsNumber, searchText, status, orderBy)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "GetPeople"]);    
    var queryParams = {"pageNumber":pageNumber, "resultsNumber":resultsNumber, "searchText":searchText, "status":status, "orderBy": orderBy};

    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader()}
    };
    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}

function add(person, photo) {
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "RegisterUser"]); 
    
    let formData = new FormData();
    formData.append("firstName", person.firstName);
    formData.append("hourlyRating", person.hourlyRating);
    formData.append("password", person.password);
    formData.append("accessCode", person.accessCode);
    if(person.lastName) formData.append("lastName", person.lastName);
    if(person.role) formData.append("role", person.lastName);
    if(person.telephone) formData.append("telephone", person.telephone);
    if(person.notes) formData.append("notes", person.notes);
    if(photo) formData.append("photo", photo);

    const requestOptions = {
        method: 'POST',
        body: formData,
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function edit(id, person, photo) {
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "UpdatePerson", id]); 

    let formData = new FormData();
    formData.append("firstName", person.firstName);
    formData.append("hourlyRating", person.hourlyRating);
    if(person.lastName) formData.append("lastName", person.lastName);
    if(person.role) formData.append("role", person.lastName);
    if(person.telephone) formData.append("telephone", person.telephone);
    if(person.notes) formData.append("notes", person.notes);
    if(photo) formData.append("photo", photo);

    const requestOptions = {
        method: 'PUT',
        body: formData,
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function get(id)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "GetPerson", id]);    
    const requestOptions = {
        method: 'GET' ,
        headers: { ...authHeader()}
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function updateStatus(id, status) {
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "UpdateStatus", id, status]);

    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function updateCredentials(id, password, accessCode) {
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "UpdateCredentials", id]);

    let formData = new FormData();
    formData.append("password", password);
    formData.append("accessCode", accessCode);

    const requestOptions = {
        method: 'PUT',
        body: formData,
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions, false);
}